import React from 'react';
// import ShowMoreText from 'react-show-more-text';

const platformsNonClickable = {
  facebook: (
    <div className="platform-description">
        Please, put Advaice business id as Authorized Business under App
        Settings -&gt; Advanced -&gt; Advertising accounts. Advaice business id:
        431336024050239
    </div>
  ),
  instagram: (
    <div className="platform-description">
        Please, put Advaice business id as Authorized Business under App
        Settings -&gt; Advanced -&gt; Advertising accounts. Advaice business id:
        431336024050239
    </div>
  ),
  google: (
    /* eslint-disable */
    <div className="platform-description-none-text">
    </div>
  ),
  mytarget: (
    /* eslint-disable */
    <div className="platform-description-none-text">
    </div>
  ),
  tiktok: (
    /* eslint-disable */
    <div className="platform-description-none-text">
    </div>
  ),
  vk: (
    /* eslint-disable */
    <div className="platform-description-none-text">
    </div>
  ),
};

export default platformsNonClickable;



// WEBPACK FOOTER //
// ./src/containers/CreateCampaign/components/CreateCampaignForm/assets/platformsNonClickable.js